"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _h = _interopRequireDefault(require("./h1"));

var _h2 = _interopRequireDefault(require("./h2"));

var _h3 = _interopRequireDefault(require("./h3"));

var _h4 = _interopRequireDefault(require("./h4"));

var _h5 = _interopRequireDefault(require("./h5"));

var _h6 = _interopRequireDefault(require("./h6"));

var _label = _interopRequireDefault(require("./label"));

var _p = _interopRequireDefault(require("./p"));

var _span = _interopRequireDefault(require("./span"));

var _excluded = ["textRef", "tag"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TagMap = {
  h1: _h["default"],
  h2: _h2["default"],
  h3: _h3["default"],
  h4: _h4["default"],
  h5: _h5["default"],
  h6: _h6["default"],
  label: _label["default"],
  p: _p["default"],
  span: _span["default"]
};

var Text = function Text(_ref) {
  var textRef = _ref.textRef,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "span" : _ref$tag,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Tag = TagMap[tag];
  return Tag ? /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    ref: textRef
  }, props)) : /*#__PURE__*/_react["default"].createElement(_span["default"], _extends({
    as: tag,
    ref: textRef
  }, props));
};

Text.propTypes = {
  tag: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string]),
  textRef: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
    current: _propTypes.object
  })])
};
Text.displayName = "Primitives.Text";
var _default = Text;
exports["default"] = _default;